// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';
$w.onReady(function () {
	//TODO: write your page related code here...
	if(wixWindow.formFactor === "Mobile"){
  		$w("#vectorImage1").show();
 }
});

export function vectorImage1_viewportLeave(event, $w) {
	//Add your code for this event here: 
}